<template>
  <div class="contact">
     <div class="wrap contact-box">
       <div class="left">
         <h3>联系我们</h3>
         <p>ADD:广东省中山市石岐街道中山二路4号星汇湾1幢16层04卡</p>
         <p>TEL:13971940942</p>
       </div>
       <!-- <div class="right">
         <h3>WeChat</h3>
         <div class="pic"><img src="@/assets/images/WeChat.jpg"></div>
         <a>@请咨询解决方案顾问</a>
       </div> -->
       
     </div>
  </div>
</template>
  
  <script>
  export default {
    data() {
      return {};
    },
  };
  </script>
  
  <style scoped>
  .contact{
    width: 100%;
    padding: 90px 0;
  }
  .contact-box{
    display: flex;
    justify-content: space-between;
  }
  .contact-box h3{
    font-size: 24px;
  }

  .contact-box h3::after{
    content: '';
    width: 500px;
    height: 1px;
    background: #e3e3e3;
    display: block;
    margin: 15px 0;
  }

  .contact-box .left p{
    font-size: 14px;
    line-height: 32px;
  }
  .contact-box .right a{
    padding: 10px 15px;
    border: 1px solid #313131;
    display: inline-block;
    font-size: 14px;
  }
  .contact-box .right .pic{
    overflow: hidden;
    margin: 20px 0;
  }
  .contact-box .right .pic img{
    display: block;
    width: 130px;
    height: 130px;
  }
 
  </style>
  